import { graphql } from '@/graphql';

export const googleImagesByPositionQuery = graphql(`
  query GoogleImagesByPosition($lat: Float!, $lng: Float!) {
    images: googleImagesByPosition(lat: $lat, lng: $lng) {
      id
      panoId
      root
      heading
      roll
      tilt
      width
      height
      copyright
      date
      locationWGS84
      createdAt
    }
  }
`);
